<!--
 * @Author: your name
 * @Date: 2020-09-28 19:29:53
 * @LastEditTime: 2020-10-11 14:18:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \bidding-oa-web\src\views\home\logined.vue
-->
<template>
  <el-card>
    <div class="ch-user">
      <div class="avatar">
        <el-avatar :size="80" :src="avatarImg"></el-avatar>
      </div>
      <div class="nickname">Hi欢迎来到金沫旅游</div>
      <div class="ch-name">{{name}}{{phone}}</div>
    </div>
    <el-divider></el-divider>
    <div class="ch-flex" v-if="data">
      <div class="ch-flex-item" @click="goto('/user/project')">
        <div class="ch-flex-num">{{data.waitBidCount}}</div>
        <div class="ch-flex-label">待开标</div>
      </div>
      <div class="ch-flex-item" @click="goto('/user/project')">
        <div class="ch-flex-num">{{data.noBidCount}}</div>
        <div class="ch-flex-label">不通过</div>
      </div>
      <div class="ch-flex-item" @click="goto('/user/project')">
        <div class="ch-flex-num">{{data.winBidCount}}</div>
        <div class="ch-flex-label">已中标</div>
      </div>
    </div>
  </el-card>
</template>
<script>
import announcement from "@/api/announcement/announcement"
export default {
  data(){
    return{
      avatarImg:JSON.parse(localStorage.getItem("userInfo")).avatar,
      name:JSON.parse(localStorage.getItem("userInfo")).companyName,
      phone:JSON.parse(localStorage.getItem("userInfo")).phone,
      data:{}
    }
  },
  created() {
    this.countSupplierOpenBidInfo()
    let str = this.$router.params.id
  },
  methods: {
    /**
     * 哆啦A梦任意门go
     */
    goto(url) {
      this.$router.push({
        path:url
      })
    },
    countSupplierOpenBidInfo(){
      announcement.countSupplierOpenBidInfo().then(res =>{
        this.data = res.data
      })
    }
  },
};
</script>

<style lang="less" scoped>
.el-divider{
  margin: 0;
}
/deep/ .el-card__body{
  padding: 0;
}
.ch-user {
  text-align: center;
  padding: 20px 0 18px; 
}
.nickname {
  font-size: 14px;
  color: #333333;
  margin-top: 10px;
}
.ch-name{
  margin-top: 10px;
font-size: 14px;
font-weight: 300;
color: #3984F7;
}
.button-box + .button-box {
  margin-top: 15px;
}
.button {
  display: block;
  width: 100%;
}
.ch-flex {
  display: flex;
  padding: 20px 0 18px; 
  > .ch-flex-item {
    cursor: pointer;
    flex: 1;
    text-align: center;
    > .ch-flex-num {
      font-size: 22px;
      font-weight: 400;
      color: #fd9a25;
    }
    .ch-flex-label {
      font-size: 14px;
      font-weight: 300;
      color: #222222;
    }
  }
}
</style>